/**
 * EdDrawer组件底部按钮属性
 */
export const FooterProps = {
    loading: {type: Boolean},
    /**
     * @description: Show close button
     */
    showCancelBtn: {type: Boolean, default: true},
    cancelButtonProps: {
        type: Object,
        default: () => {
            return {
                size: 'small',
            }
        }
    },
    cancelText: {type: String, default: '关 闭'},
    /**
     * @description: Show confirmation button
     */
    showOkBtn: {type: Boolean, default: true},
    okButtonProps: {
        type: Object,
        default: () => {
            return {
                size: 'small',
                type: "primary"
            }
        }
    },
    okText: {type: String, default: '确 定'},
    showFooter: {type: Boolean, },
    footerHeight: {type: [String, Number], default: 60,},
}

/**
 * EdDrawer组件属性
 */
export default {
    // Drawer 自身是否插入至 body 元素上。嵌套的 Drawer 必须指定该属性并赋值为 true
    appendToBody: {type: Boolean, default: true},
    // 关闭前的回调，会暂停 Drawer 的关闭
    beforeClose: {type: Function},
    // 是否可以通过按下 ESC 关闭 Drawer
    closeOnPressEscape: {type: Boolean, default: true},
    // Drawer 的自定义类名
    customClass: {type: String, default: "ed-drawer"},
    // 控制是否在关闭 Drawer 之后将子元素全部销毁
    destroyOnClose: {type: Boolean, default: true},
    // 是否需要遮罩层
    modal: {type: Boolean, default: true},
    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Drawer 的父元素上
    modalAppendToBody: {type: Boolean, default: true},
    // Drawer 打开的方向  rtl / ltr / ttb / btt
    direction: {type: String, default: 'rtl'},
    // 是否显示关闭按钮
    showClose: {type: Boolean, default: true},
    // Drawer 窗体的大小, 当使用 number 类型时, 以像素为单位, 当使用 string 类型时, 请传入 'x%', 否则便会以 number 类型解释
    size: {type: [Number, String], default: '40%'},
    // Drawer 的标题，也可通过具名 slot （见下表）传入
    title: {type: String},
    // 是否显示 Drawer，支持 .sync 修饰符
    visible: {type: Boolean, default: false},
    // 点击遮罩层是否可以关闭 Drawer
    wrapperClosable: {type: Boolean, default: true},
    // 控制是否显示 header 栏, 默认为 true, 当此项为 false 时, title attribute 和 title slot 均不生效
    withHeader: {type: Boolean, default: true},

    ...FooterProps
}
